import { Routes, RouterModule } from '@angular/router';

import { hisChildRoutes } from 'hisng';

import { ResearchInfrastructureEditFormComponent } from './component/edit/research-infrastructure-edit-form.component';
import { ResearchInfrastructureSearchFormComponent } from './component/search/research-infrastructure-search-form.component';
import { ResearchInfrastructureSearchResultComponent } from './component/search/research-infrastructure-search-result.component';
import { ResearchInfrastructureViewDetailsComponent } from './component/view/research-infrastructure-view-details.component';
import { ResearchInfrastructureModuleOptions } from './research-infrastructure-module.options';

const ROUTES: Routes = [
    {
        path: 'create',
        component: ResearchInfrastructureEditFormComponent,
        data: {
            hasAny: ResearchInfrastructureModuleOptions.RIGHT_CREATE
        }
    },
    {
        path: 'edit/:id',
        component: ResearchInfrastructureEditFormComponent,
        data: {
            hasAny: ResearchInfrastructureModuleOptions.RIGHT_EDIT
        }
    },
    {
        path: 'search',
        component: ResearchInfrastructureSearchFormComponent,
        data: {
            hasAny: [
                ...ResearchInfrastructureModuleOptions.RIGHT_EDIT,
                ...ResearchInfrastructureModuleOptions.RIGHT_VIEW
            ]
        }
    },
    {
        path: 'searchresult',
        component: ResearchInfrastructureSearchResultComponent,
        data: {
            hasAny: [
                ...ResearchInfrastructureModuleOptions.RIGHT_EDIT,
                ...ResearchInfrastructureModuleOptions.RIGHT_VIEW
            ]
        }
    },
    {
        path:'view/:id',
        component: ResearchInfrastructureViewDetailsComponent,
        data: {
            hasAny: ResearchInfrastructureModuleOptions.RIGHT_VIEW,
            modules: ['HISINONERES']
        }
    }
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ResearchInfrastructureRoutesModule = hisChildRoutes( ROUTES );
